export { default } from './TransLabel';